import { useContext } from 'react';

import PromotionsContext from './promotions.context';

function usePromotions() {
  const context = useContext(PromotionsContext);

  if (!context) {
    throw new Error('usePromotions must be used within PromotionsContext');
  }

  return context;
}

export default usePromotions;